import Plyr from 'plyr';

document.addEventListener('DOMContentLoaded', () => {

    const controls = [
        'play', // Play/pause playback
        'progress', // The progress bar and scrubber for playback and buffering
        'current-time', // The current time of playback
        'duration', // The full duration of the media
        'mute', // Toggle mute
        'volume', // Volume control
        'fullscreen' // Toggle fullscreen
    ];

    if ( document.querySelectorAll('.js-player').length > 0 ) {
        const players = Plyr.setup('.js-player', {
            youtube: { noCookie: true },
            vimeo: { dnt: true },
            loop: { active : true },
            volume: 0,
            autoplay: false,
            muted: true,
            controls: `<div class="plyr__controls">
            <button type="button" class="plyr__control plyr__controls__item" aria-label="Play, {title}" data-plyr="play">
        <svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-pause"></use></svg>
        <svg class="svg-icon btn__icon icon--not-pressed"  width="34" height="34" viewBox="0 0 24 24">
            <path d="M19 12L7 19V5l12 7z" fill="currentColor"></path>
          </svg>
    </button></div>`,
            hideControls: false
        });
    }

    if ( document.querySelectorAll('.js-player-auto').length > 0 ) {
        const playersAuto = Plyr.setup('.js-player-auto', {
            youtube: { noCookie: true },
            vimeo: { dnt: true },
            loop: { active : true },
            volume: 0,
            autoplay: true,
            muted: true,
            controls: `<div class="plyr__controls">
            <button type="button" class="plyr__control plyr__controls__item" aria-label="Play, {title}" data-plyr="play">
        <svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-pause"></use></svg>
        <svg class="svg-icon btn__icon icon--not-pressed"  width="34" height="34" viewBox="0 0 24 24">
            <path d="M19 12L7 19V5l12 7z" fill="currentColor"></path>
          </svg>
    </button></div>`,
            hideControls: false
        });
    }

    if ( document.querySelectorAll('.js-player-controls').length > 0 ) {
        const playersAutoControls = Plyr.setup('.js-player-auto-controls', {
            youtube: { noCookie: true },
            vimeo: { dnt: true },
            loop: { active : true },
            volume: 0.5,
            autoplay: false,
            muted: true,
            controls
        });
    }

    if ( document.querySelectorAll('.js-player-auto-controls').length > 0 ) {
        const playersAutoControls = Plyr.setup('.js-player-auto-controls', {
            youtube: { noCookie: true },
            vimeo: { dnt: true },
            loop: { active : true },
            volume: 0.5,
            autoplay: true,
            muted: true,
            controls
        });
    }

    if ( document.querySelectorAll('.js-player-no-auto-no-controls').length > 0 ) {
        const playersAutoControls = Plyr.setup('.js-player-no-auto-no-controls', {
            youtube: { noCookie: true },
            vimeo: { dnt: true },
            loop: { active : true },
            volume: 0,
            autoplay: false,
            muted: true,
            controls: false,
            fullscreen: {enabled: false},
            clickToPlay: false
        });
    }
});